/*
 * Title: Rewards/RedeemContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Redeem Content page content listing, click on list popup will shows from bottom.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import Buttonlink from "@components/Button";
import { connect } from "react-redux";
import { numberFormat, routerLink } from "@helpers/common";

type Props = {};
type MyState = {
  toggleHeight: boolean;
};
class RedeemContentItem extends React.Component<Props | any, MyState> {
  state: MyState = {
    toggleHeight: false,
  };

  toggleHandler = () => {
    this.setState({ toggleHeight: !this.state.toggleHeight });
  };

  render() {
    let { item, user, jwt_token } = this.props;
    item = item.reward;
    return (
      <>
        <a
          href={!jwt_token ? `${routerLink(user?.username)}?ref=signin` : `${routerLink(user?.username)}/redeem`}
          //onClick={!jwt_token ? null : this.toggleHandler}
          className="block">
          <div
            // onClick={this.toggleHandler}
            className={`${
              this.state.toggleHeight
                ? "max-h-[100vh] ease-in-out duration-1000"
                : "max-h-[150px] ease-in-out duration-700"
            } bg-[#1D1D1D] p-[20px] transition-all rounded-[10px] relative cursor-pointer overflow-hidden`}>
            {/* pills  */}
            <div className="flex flex-col justify-center pt-1">
              <div className="flex flex-wrap items-center gap-x-2">
                <div className="bg-[#000]/50 h-[28px] lg:h-[32px] px-5 rounded-full flex items-center justify-center">
                  <p className="lightBlack lg:text-[14px] text-[12px] uppercase font-normal tracking-wider">
                    {numberFormat(item.limit)} Points
                  </p>
                </div>
              </div>
              <h4 className="font-medium text-white lg:text-[20px] text-[18px] mt-[15px] capitalize">
                {item.title}
              </h4>
            </div>
            {/* expanded  */}
            <p
              className={`${
                this.state.toggleHeight ? null : "truncate"
              } lightBlack text-[16px] font-normal tracking-wider mt-[15px] min-h-[26px]`}>
              {item.description}
            </p>
            <div
              className={`${
                this.state.toggleHeight ? "opacity-100" : "opacity-100"
              } space-y-6 duration-700 ease-in-out transition-opacity`}></div>
            <div className="divide-y h-[1px] w-full bg-gray-600 my-[35px]" />
            <div className="text-center">
              <Buttonlink
                text="redeem"
                className="font-medium bg-lightBlack rounded-full text-[#fff]/50 w-full max-w-[300px] mx-auto py-2.5 opacity-80"
              />
            </div>
            <div className="text-center mt-[15px]">
              <a
                href={`${routerLink(user?.username)}?ref=signin`}
                className="font-medium uppercase primary hover:opacity-80">
                Earn Now
              </a>
            </div>
          </div>
        </a>
      </>
    );
  }
}

const mapStateToProps = ({ user, creator }) => {
  return {
    jwt_token: user.user.token,
    user: creator.data,
  };
};
export default connect(mapStateToProps)(RedeemContentItem);
